import React, { useContext, useState, useEffect } from 'react';
import { InputContext } from '../contexts/InputContext';
import authServices from '../services/authServices';
import MessageModal from '../container/MessageModal';
import { errorClassification } from '../errorHandler';
import { useNavigate } from "react-router-dom";
import TextControl from '../container/customizedInputs/TextControl';
import SelectControl from '../container/customizedInputs/SelectControl';
import usuariosServices from '../services/usuariosServices';

const Registro = () => {
  const navigate = useNavigate();

  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [datosUsuario, setDatosUsuario] = useState({});
  const [renderHTML, setRenderHTML] = useState(false);
  const [provincias, setProvincias] = useState([]);
  const [registroFinalizado, setRegistroFinalizado] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if( (authInformation.autenticado === true)){
      navigate(`/ingreso`);
    } else {
      setRenderHTML(true)
      nuevoUsuario()
      obtenerProvincias()
    }
  }, [authInformation]);

  const nuevoUsuario = async () => {
    try {
      const data = await usuariosServices.nuevoUsuario();
      setDatosUsuario(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const obtenerProvincias = async () => {
    try {
      const data = await usuariosServices.obtenerProvincias();
      setProvincias(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const signUp = async () => {
    try {
      const data = await authServices.signUp(datosUsuario);
      
      setRegistroFinalizado(true)

      // setOferta(data);
      // setTotalPages(data.meta.total_pages);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      // usado para valores anidados
      const [parentKey, childKey] = name.split('.');
      setDatosUsuario((datosUsuario) => ({
        ...datosUsuario,
        [parentKey]: {
          ...datosUsuario[parentKey],
          [childKey]: value,
        },
      }));
    } else {
      setDatosUsuario({...datosUsuario,
        [name]: value
      })
    }
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    // if (!datosUsuario.email || !datosUsuario.password || !datosUsuario.nombre || !datosUsuario.apellido || !datosUsuario.documento_identidad) {
    //   alert('Por favor, ingrese su email, nombre, apellido, documento de identidad y contraseña.');
    //   return;
    // }
    signUp()

  }

  return (
    <div>
      {renderHTML && (
        <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
        <form>
          <h1 className="h3 mb-3 fw-normal">Registrate aquí</h1>
          {/* <pre>{JSON.stringify(datosUsuario, null, 2)}</pre> */}
          {
            registroFinalizado ? (
              <div className="alert alert-warning" role="alert">
                Ahora tenés que activar tu usuario. Revisá tu email para continuar (si no ves el email en bandeja de entrada, revisá tu correo no deseado)
              </div>
            ) : (
              <div id="carouselExample" className="carousel slide">
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <TextControl
                      className='mb-3'
                      value={datosUsuario.email}
                      name={'email'}
                      handleInput={handleInput}
                      type='email'
                      label='Correo electrónico'
                      />

                    <TextControl
                      className='mb-3'
                      value={datosUsuario.nombre}
                      name={'nombre'}
                      handleInput={handleInput}
                      />

                    <TextControl
                      className='mb-3'
                      value={datosUsuario.apellido}
                      name={'apellido'}
                      handleInput={handleInput}
                      />

                    <TextControl
                      className='mb-3'
                      value={datosUsuario.documento_identidad}
                      name={'documento_identidad'}
                      handleInput={handleInput}
                      label='Documento de identidad'
                      />

                    <TextControl
                      className='mb-3'
                      value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.cuil}
                      name={'preferencias_usuario.cuil'}
                      handleInput={handleInput}
                      label='CUIL'
                      />

                    <button className="btn btn-primary" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                      Siguiente
                    </button>
                  </div>

                  <div className="carousel-item">
                    <div className="card mb-3">
                      <div className="card-body">
                        <h5 className="card-title mb-3">Datos personales</h5>

                        <div className='row mb-3'>
                          <div className='col-sm-6'>
                          <TextControl
                              className='mb-3'
                              value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.domicilio}
                              name={'preferencias_usuario.domicilio'}
                              handleInput={handleInput}
                            />
                          </div>
                          <div className='col-sm-6'>
                            <SelectControl
                              value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.provincia_id}
                              options={provincias}
                              name={'preferencias_usuario.provincia_id'}
                              handleInput={handleInput}
                              label={'Seleccione una Provincia'}
                            />
                          </div>
                          <div className='col-sm-6'>
                            <TextControl
                              className='mb-3'
                              value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.ciudad}
                              name={'preferencias_usuario.ciudad'}
                              handleInput={handleInput}
                            />
                          </div>
                          <div className='col-sm-6'>
                            <TextControl
                              className='mb-3'
                              value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.codigo_postal}
                              name={'preferencias_usuario.codigo_postal'}
                              handleInput={handleInput}
                              label={'Código Postal'}
                            />
                          </div>
                        </div>
                        <div className="card mb-3">
                          <div className="card-body">
                            <h5 className="card-title">Teléfonos</h5>
                              <div className='row mb-3'>
                                <div className='col-sm-6'>
                                  <TextControl
                                    className='mb-3'
                                    value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.telefono_movil}
                                    name={'preferencias_usuario.telefono_movil'}
                                    handleInput={handleInput}
                                  />
                                </div>
                                <div className='col-sm-6'>
                                  <TextControl
                                    className='mb-3'
                                    value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.telefono_fijo}
                                    name={'preferencias_usuario.telefono_fijo'}
                                    handleInput={handleInput}
                                  />
                                </div>
                                <div className='col-sm-6'>
                                  <TextControl
                                    className='mb-3'
                                    value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.telefono_laboral}
                                    name={'preferencias_usuario.telefono_laboral'}
                                    handleInput={handleInput}
                                  />
                                </div>
                                <div className='col-sm-6'>
                                  <TextControl
                                    className='mb-3'
                                    value={datosUsuario.preferencias_usuario && datosUsuario.preferencias_usuario.fax}
                                    name={'preferencias_usuario.fax'}
                                    handleInput={handleInput}
                                  />
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>

                    <button className="btn btn-primary" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                      Volver
                    </button>
                    <button className="btn btn-primary ms-3" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                      Siguiente
                    </button>
                  </div>

                  <div className="carousel-item">
                    <TextControl
                      className='mb-3'
                      value={datosUsuario.password}
                      name={'password'}
                      handleInput={handleInput}
                      type={'password'}
                      label='Clave'
                      />

                    <TextControl
                      className='mb-3'
                      value={datosUsuario.password_confirmation}
                      name={'password_confirmation'}
                      handleInput={handleInput}
                      type={'password'}
                      label='Repita la clave'
                      />

                    <button className="btn btn-primary" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                      Volver
                    </button>
                    <button className="btn btn-primary ms-3" onClick={handleFormSubmit} type="submit">Registrate</button>
                  </div>
                </div>

              </div>
            )
          }


        </form>
      </main>
      )}

    <MessageModal
      showModal={showModal}
      handleCloseModal={handleCloseModal}
      modalBody={modalBody}
    />
    </div>
  );
};

export default Registro;